/**
 * Step copy for the /ancillaries wizard. Keys map to the canonical
 * AdditionalService type strings the providers emit (`bag`, `seat`,
 * `sportsEquipment`, `service`, `meal`, `loungeAccess`,
 * `disabilityAssistance`); each value carries the step's display name,
 * title, and body copy.
 *
 * The wizard reads this map in two places: `steps()` builds the
 * navigation by iterating `Object.keys(ancillaries)` and looking each
 * key up here; the active-step component pulls `title` and
 * `description` straight off the entry. Selection compatibility within
 * a step is driven by `combineWith` / `incompatibleWith` on each
 * catalog entry — every step is multi-selectable by default.
 */
export const STEP_TITLES = {
  bag: {
    name: "Bagagli da stiva",
    title: "Vuoi aggiungere un bagaglio da stiva?",
    description:
      "Puoi aggiungere bagagli da stiva separatamente per ogni passeggero e per ogni tratta.",
  },
  seat: { name: "Posti", title: "", description: "" },
  sportsEquipment: {
    name: "Attrezzatura sportiva",
    title: "Vuoi aggiungere un'attrezzatura sportiva?",
    description:
      "Puoi aggiungere attrezzature sportive separatamente per ogni passeggero e per ogni tratta. Le condizioni e i limiti di peso possono variare in base alla compagnia aerea.",
  },
  service: {
    name: "Servizi extra",
    title: "Vuoi aggiungere servizi extra?",
    description:
      "Puoi aggiungere servizi extra separatamente per ogni passeggero e per ogni tratta. La disponibilità dei servizi può variare in base alla compagnia aerea.",
  },
  meal: {
    name: "Pasti",
    title: "Vuoi aggiungere un pasto a bordo?",
    description:
      "Puoi scegliere un pasto separatamente per ogni passeggero e per ogni tratta.",
  },
  loungeAccess: {
    name: "Accesso lounge",
    title: "Vuoi aggiungere l'accesso alla lounge?",
    description:
      "Accesso alle lounge aeroportuali disponibili per questa tratta.",
  },
  disabilityAssistance: {
    name: "Assistenza disabilità",
    title: "Hai bisogno di assistenza speciale?",
    description:
      "Puoi richiedere assistenza speciale per ogni passeggero che ne ha bisogno.",
  },
};
